module.exports = __webpack_public_path__ + "static/media/logo.9bce6053.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hinkley/logo.svg
// module id = 165
// module chunks = 0